// SmsPaymentsTable.jsx
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Hoot from "../Hoot";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Select from "react-select";
import ClickAllRefreshButtons from "../ClickAllRefreshButtons";

// ===== CSS (MESMO ESTILO do ContactsListTable) =====
const smsStyles = `
:root{
  --primary:#5b5cff;
  --primary2:#7c3aed;
  --bg:#f4f6fb;
  --card:#ffffff;
  --border:#e6eaf2;
  --text:#0f172a;
  --muted:#64748b;
  --shadow: 0 14px 40px rgba(15,23,42,.08);
}

.sms-shell{
  background:var(--bg);
  padding:10px;
}

.sms-card{
  background:var(--card);
  border-radius:18px;
  border:1px solid var(--border);
  padding:12px 14px 14px;
  box-shadow: var(--shadow);
}

.sms-header{
  display:flex;
  flex-wrap:wrap;
  justify-content:space-between;
  align-items:flex-start;
  gap:10px;
  margin-bottom:10px;
}
.sms-header-title{
  font-weight:700;
  font-size:1.02rem;
  display:flex;
  align-items:center;
  gap:.55rem;
  color:var(--text);
}
.sms-chip{
  display:inline-flex;
  align-items:center;
  gap:.35rem;
  padding:.28rem .62rem;
  border-radius:999px;
  background:linear-gradient(135deg, rgba(91,92,255,.14), rgba(124,58,237,.12));
  color:#4338ca;
  font-size:.78rem;
  font-weight:600;
  border:1px solid rgba(91,92,255,.16);
}

.sms-toolbar{
  margin-top:6px;
  padding:10px 10px;
  border-radius:14px;
  background:linear-gradient(180deg, rgba(148,163,184,0.12), rgba(148,163,184,0.06));
  border:1px solid rgba(226,232,240,.7);
  margin-bottom:10px;
}

.small-muted{ font-size:.78rem; color:var(--muted); }

.kpi-row{
  display:grid; 
  gap:10px;
  margin:10px 0 12px;
}
@media (max-width: 992px){
  .kpi-row{ grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
.kpi{
  background:var(--card);
  border:1px solid var(--border);
  border-radius:16px;
  padding:10px 12px;
  box-shadow: 0 10px 28px rgba(2,6,23,.06);
  position:relative;
  overflow:hidden;
}
.kpi::before{
  content:"";
  position:absolute;
  inset:-40px -60px auto auto;
  width:120px;
  height:120px;
  border-radius:999px;
  background: radial-gradient(circle at 30% 30%, rgba(91,92,255,.18), transparent 60%);
}
.kpi-title{
  display:flex;
  align-items:center;
  gap:8px;
  font-size:.8rem;
  color:var(--muted);
  font-weight:600;
}
.kpi-value{
  margin-top:2px;
  font-size:1.18rem;
  font-weight:650;
  color:var(--text);
}
.kpi-sub{
  margin-top:2px;
  font-size:.74rem;
  color:var(--muted);
}

/* tabela desktop vs mobile */
.sms-table-wrapper{ width:100%; }
@media (max-width:768px){
  .sms-table-desktop{display:none;}
  .sms-mobile-list{display:block;}
}
@media (min-width:769px){
  .sms-table-desktop{display:block;}
  .sms-mobile-list{display:none;}
}

.sms-table{
  width:100%;
  border-collapse:separate;
  border-spacing:0;
  font-size:.86rem;
  color:var(--text);
}
.sms-table thead th{
  text-align:left;
  padding:.62rem .65rem;
  font-size:.78rem;
  font-weight:650;
  color:var(--muted);
  border-bottom:1px solid var(--border);
  background:var(--card);
  position:sticky;
  top:0;
  z-index:1;
}
.sms-table tbody td{
  padding:.62rem .65rem;
  border-bottom:1px solid var(--border);
  vertical-align:middle;
}
.sms-table tbody tr:hover{
  background:rgba(148,163,184,0.10);
}

.pill{
  display:inline-flex;
  align-items:center;
  gap:6px;
  padding:4px 10px;
  border-radius:999px;
  font-size:.74rem;
  font-weight:600;
  border:1px solid rgba(15,23,42,.08);
  background:rgba(226,232,240,.55);
  color:#0f172a;
}
.pill i{ opacity:.85; }

.logo-mini{
  width:34px;
  height:34px;
  border-radius:12px;
  border:1px solid rgba(226,232,240,.95);
  background:#fff;
  object-fit:cover;
  box-shadow: 0 10px 22px rgba(2,6,23,.08);
}

.btn-icon{
  width:34px;
  height:34px;
  border-radius:12px;
  border:1px solid rgba(226,232,240,.95);
  background:#fff;
  display:inline-grid;
  place-items:center;
  cursor:pointer;
  transition: transform .08s ease, background .12s ease;
}
.btn-icon:hover{ background: rgba(91,92,255,.06); }
.btn-icon:active{ transform: scale(.98); }
.btn-icon i{ font-size:1rem; color:#334155; }

/* mobile cards */
.sms-mobile-list{ margin-top:4px; }
.mcard{
  background:var(--card);
  border-radius:16px;
  border:1px solid var(--border);
  padding:12px 12px;
  margin:8px 0;
  box-shadow: 0 10px 26px rgba(2,6,23,.06);
}
.mrow{ display:flex; align-items:center; justify-content:space-between; gap:12px; }
.mline{ height:1px; background:var(--border); margin:10px 0; }
.mtitle{ font-weight:650; color:var(--text); font-size:.92rem; }
.msub{ color:var(--muted); font-size:.78rem; margin-top:2px; }

/* modal bonito */
.pretty-modal .modal-content{
  border-radius:20px;
  border:1px solid rgba(226,232,240,.9);
  box-shadow: 0 24px 80px rgba(2,6,23,.20);
  overflow:hidden;
}
.pretty-modal .modal-header{
  border-bottom:1px solid rgba(226,232,240,.9);
  background: radial-gradient(1200px 300px at 20% 0%, rgba(91,92,255,.16), transparent 60%),
              radial-gradient(900px 260px at 90% 0%, rgba(124,58,237,.12), transparent 55%),
              #ffffff;
}
.pretty-modal .modal-title{
  font-weight:700;
  color:#0f172a;
}
`;

// ===== react-select styles (FULL WIDTH, igual "barra de pesquisa") =====
const selectStyles = {
  container: (base) => ({ ...base, width: "100%" }),
  control: (base, state) => ({
    ...base,
    width: "100%",
    borderRadius: 999,
    borderColor: state.isFocused ? "rgba(91,92,255,.45)" : "rgba(226,232,240,.9)",
    boxShadow: state.isFocused ? "0 0 0 .2rem rgba(91,92,255,.12)" : "none",
    minHeight: 40,
    paddingLeft: 6,
  }),
  valueContainer: (base) => ({ ...base, padding: "0 12px" }),
  placeholder: (base) => ({ ...base, color: "#94a3b8", fontSize: ".9rem" }),
  menu: (base) => ({ ...base, borderRadius: 14, overflow: "hidden", zIndex: 9999 }),
};

// ===== utils =====
const safeValue = (v, fallback = "—") => (v === null || v === undefined || v === "" ? fallback : v);

const moneyAOA = (value) =>
  new Intl.NumberFormat("pt-AO", { style: "currency", currency: "AOA" }).format(Number(value || 0));

const formatSmsDate = (dateStr) => {
  if (!dateStr) return "";
  const normalized = String(dateStr).replace(" ", "T");
  const date = new Date(normalized);
  if (isNaN(date.getTime())) return "";
  return date.toLocaleString("en-GB", { hour12: false });
};

const renderPagination = (pageCount, currentPage, setCurrentPage) => {
  if (pageCount <= 1) return null; // se só houver 1 página, não mostra paginação

  const pages = [];
  const maxButtons = 7;

  if (pageCount <= maxButtons) {
    for (let i = 1; i <= pageCount; i++) pages.push(i);
  } else {
    pages.push(1);
    let start = Math.max(2, currentPage - 1);
    let end = Math.min(pageCount - 1, currentPage + 1);

    if (start > 2) pages.push("...");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < pageCount - 1) pages.push("...");
    pages.push(pageCount);
  }

  return (
    <nav>
      <ul className="pagination pagination-sm mb-0">
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <button className="page-link" onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}>
            «
          </button>
        </li>

        {pages.map((p, idx) =>
          p === "..." ? (
            <li key={`ellipsis-${idx}`} className="page-item disabled">
              <span className="page-link">…</span>
            </li>
          ) : (
            <li key={p} className={`page-item ${currentPage === p ? "active" : ""}`}>
              <button className="page-link" onClick={() => setCurrentPage(p)}>
                {p}
              </button>
            </li>
          )
        )}

        <li className={`page-item ${currentPage === pageCount ? "disabled" : ""}`}>
          <button className="page-link" onClick={() => setCurrentPage((p) => Math.min(pageCount, p + 1))}>
            »
          </button>
        </li>
      </ul>
    </nav>
  );
};

const SmsPaymentsTable = () => {
  const [payments, setPayments] = useState([]);
  const [search, setSearch] = useState(""); // value = institute_name lowercase
  const [currentPage, setCurrentPage] = useState(1);

  const [selectedSmsPaymentId, setSelectedSmsPaymentId] = useState(null);
  const [selectedInstituteCode, setSelectedInstituteCode] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [loading, setLoading] = useState(false);

  const itemsPerPage = 10;

  const loadSmsPayments = async () => {
    try {
      setLoading(true);
      const res = await axios.get(Hoot() + "get-all-sms-payments", {
        withCredentials: true,
      });
      setPayments(res.data || []);
    } catch (error) {
      console.error("Erro ao carregar pagamentos de SMS:", error);
      toast.error("Erro ao carregar pagamentos de SMS.");
    } finally {
      setLoading(false);
    }
  };

  const handleSmsCancel = async () => {
    try {
      if (!selectedSmsPaymentId || !selectedInstituteCode) return;

      await axios.delete(Hoot() + "sms-payments/" + selectedSmsPaymentId, {
        data: { instituteCode: selectedInstituteCode },
        withCredentials: true,
      });

      toast.success("Pagamento de SMS anulado com sucesso!");
      setShowModal(false);
      await loadSmsPayments();
      ClickAllRefreshButtons();
    } catch (error) {
      toast.warning("Erro ao anular o pagamento de SMS.");
      console.log(error);
    }
  };

  useEffect(() => {
    loadSmsPayments();
  }, []);

  // Search options (react-select)
  const searchOptions = useMemo(() => {
    const map = new Map();
    (payments || []).forEach((item) => {
      const name = item?.ed_institute_name || "";
      if (!name) return;
      if (!map.has(name)) map.set(name, { label: name, value: name.toLowerCase() });
    });
    return Array.from(map.values()).sort((a, b) => a.label.localeCompare(b.label, "pt"));
  }, [payments]);

  const filteredPayments = useMemo(() => {
    return (payments || []).filter((item) => {
      const name = item?.ed_institute_name?.toLowerCase() || "";
      return search === "" || name === search;
    });
  }, [payments, search]);

  // KPIs
  const kpis = useMemo(() => {
    const total = filteredPayments.length;

    const totalSms = filteredPayments.reduce(
      (acc, it) => acc + Number(it?.ed_sms_pay_totalpaidsms || 0),
      0
    );

    const totalAmount = filteredPayments.reduce(
      (acc, it) => acc + Number(it?.ed_sms_pay_totalamount || 0),
      0
    );

    const avgUnit = filteredPayments.length
      ? filteredPayments.reduce((acc, it) => acc + Number(it?.ed_sms_pay_smsvalue || 0), 0) / filteredPayments.length
      : 0;

    return { total, totalSms, totalAmount, avgUnit };
  }, [filteredPayments]);

  // Pagination
  const pageCount = Math.ceil(filteredPayments.length / itemsPerPage) || 1;
  const paginatedPayments = filteredPayments.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      <style>{smsStyles}</style>

      <div className="sms-shell">
        <div className="sms-card">
          {/* HEADER */}
          <div className="sms-header">
            <div className="sms-header-title">
              <i className="bi bi-chat-left-text-fill" style={{ color: "var(--primary)" }} />
              <span>Pagamentos de SMS</span>
              <span className="sms-chip">
                <i className="bi bi-receipt-cutoff" />
                {filteredPayments.length} registos
              </span>
            </div>

            <div className="d-flex flex-wrap gap-2">
              <button
                className="btn btn-outline-dark btn-sm rounded-pill d-flex align-items-center"
                onClick={loadSmsPayments}
                disabled={loading}
                title="Recarregar"
              >
                <i className="bi bi-arrow-clockwise me-1" />
                Recarregar
              </button>
            </div>
          </div>

          {/* TOOLBAR (apenas barra de pesquisa full width) */}
          <div className="sms-toolbar">
            <div className="row g-2">
              <div className="col-12">
                <Select
                  options={searchOptions}
                  placeholder="Pesquisar Escola…"
                  onChange={(selectedOption) => {
                    setSearch(selectedOption?.value || "");
                    setCurrentPage(1);
                  }}
                  isClearable
                  styles={selectStyles}
                />
              </div>
            </div>
          </div>

          {/* KPI BOXES */}
          <div className="kpi-row">
            <div className="kpi">
              <div className="kpi-title">
                <i className="bi bi-collection" /> Total (filtro)
              </div>
              <div className="kpi-value">{kpis.total}</div>
              <div className="kpi-sub">Registos encontrados</div>
            </div>

            <div className="kpi">
              <div className="kpi-title" style={{ color: "#3b82f6" }}>
                <i className="bi bi-envelope-paper-fill" /> Total SMS
              </div>
              <div className="kpi-value">{kpis.totalSms.toLocaleString("pt-PT")}</div>
              <div className="kpi-sub">Somatório de SMS pagos</div>
            </div>

            <div className="kpi">
              <div className="kpi-title" style={{ color: "#16a34a" }}>
                <i className="bi bi-cash-coin" /> Total pago
              </div>
              <div className="kpi-value">{moneyAOA(kpis.totalAmount)}</div>
              <div className="kpi-sub">Somatório de pagamentos</div>
            </div>

            <div className="kpi">
              <div className="kpi-title" style={{ color: "#f59e0b" }}>
                <i className="bi bi-graph-up-arrow" /> Preço médio (unit.)
              </div>
              <div className="kpi-value">{moneyAOA(kpis.avgUnit)}</div>
              <div className="kpi-sub">Média do preço por SMS</div>
            </div>
          </div>

          {/* TABLE */}
          <div className="sms-table-wrapper">
            {/* Desktop table */}
            <div className="sms-table-desktop">
              <table className="sms-table">
                <thead>
                  <tr>
                    <th>Instituição</th>
                    <th>Operador</th>
                    <th>Data</th>
                    <th>Total SMS</th>
                    <th>Preço unit.</th>
                    <th>Total pago</th>
                    <th className="text-end">Ação</th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedPayments.map((item) => (
                    <tr key={item.ed_sms_pay_id}>
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <img
                            className="logo-mini"
                            src={`https://sv.eduall.pt/${item.ed_institute_logo}`}
                            alt={safeValue(item.ed_institute_name, "Logo")}
                            onError={(e) => {
                              e.currentTarget.style.display = "none";
                            }}
                          />
                          <div>
                            <div style={{ fontWeight: 650 }}>{safeValue(item.ed_institute_name, "Sem nome")}</div>
                            <div className="small-muted">
                              <i className="bi bi-hash me-1" />
                              {safeValue(item.ed_sms_pay_institutioncode, "Sem código")}
                            </div>
                          </div>
                        </div>
                      </td>

                      <td>
                        <span className="pill">
                          <i className="bi bi-person-badge-fill" />
                          {safeValue(item.ed_sms_pay_operator, "—")}
                        </span>
                      </td>

                      <td>
                        <span className="pill">
                          <i className="bi bi-clock-history" />
                          {safeValue(formatSmsDate(item.ed_sms_pay_date), "—")}
                        </span>
                      </td>

                      <td>{Number(item.ed_sms_pay_totalpaidsms || 0).toLocaleString("pt-PT")}</td>
                      <td>{moneyAOA(item.ed_sms_pay_smsvalue)}</td>
                      <td style={{ fontWeight: 700 }}>{moneyAOA(item.ed_sms_pay_totalamount)}</td>

                      <td className="text-end">
                        <button
                          className="btn-icon"
                          type="button"
                          title="Anular pagamento"
                          onClick={() => {
                            setSelectedSmsPaymentId(item.ed_sms_pay_id);
                            setSelectedInstituteCode(item.ed_sms_pay_institutioncode);
                            setShowModal(true);
                          }}
                        >
                          <i className="bi bi-trash3" style={{ color: "#ef4444" }} />
                        </button>
                      </td>
                    </tr>
                  ))}

                  {paginatedPayments.length === 0 && (
                    <tr>
                      <td colSpan={7}>
                        <span className="small-muted">Nenhum pagamento encontrado para os filtros actuais.</span>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Mobile cards */}
            <div className="sms-mobile-list">
              {paginatedPayments.map((item) => (
                <div className="mcard" key={item.ed_sms_pay_id}>
                  <div className="mrow">
                    <div className="d-flex align-items-center gap-2">
                      <img
                        className="logo-mini"
                        src={`https://sv.eduall.pt/${item.ed_institute_logo}`}
                        alt={safeValue(item.ed_institute_name, "Logo")}
                        onError={(e) => {
                          e.currentTarget.style.display = "none";
                        }}
                      />
                      <div>
                        <div className="mtitle">{safeValue(item.ed_institute_name, "Sem nome")}</div>
                        <div className="msub">Código: {safeValue(item.ed_sms_pay_institutioncode, "—")}</div>
                      </div>
                    </div>

                    <button
                      className="btn-icon"
                      type="button"
                      title="Anular"
                      onClick={() => {
                        setSelectedSmsPaymentId(item.ed_sms_pay_id);
                        setSelectedInstituteCode(item.ed_sms_pay_institutioncode);
                        setShowModal(true);
                      }}
                    >
                      <i className="bi bi-trash3" style={{ color: "#ef4444" }} />
                    </button>
                  </div>

                  <div className="mline" />

                  <div className="d-flex flex-wrap gap-2">
                    <span className="pill">
                      <i className="bi bi-person-badge-fill" />
                      {safeValue(item.ed_sms_pay_operator, "—")}
                    </span>

                    <span className="pill">
                      <i className="bi bi-clock-history" />
                      {safeValue(formatSmsDate(item.ed_sms_pay_date), "—")}
                    </span>

                    <span className="pill">
                      <i className="bi bi-envelope-paper-fill" />
                      {Number(item.ed_sms_pay_totalpaidsms || 0).toLocaleString("pt-PT")} SMS
                    </span>
                  </div>

                  <div className="mline" />

                  <div className="d-flex justify-content-between align-items-center">
                    <div className="small-muted">Preço unit.</div>
                    <div style={{ fontWeight: 700 }}>{moneyAOA(item.ed_sms_pay_smsvalue)}</div>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mt-1">
                    <div className="small-muted">Total pago</div>
                    <div style={{ fontWeight: 800, color: "#16a34a" }}>{moneyAOA(item.ed_sms_pay_totalamount)}</div>
                  </div>
                </div>
              ))}

              {paginatedPayments.length === 0 && (
                <span className="small-muted">Nenhum pagamento encontrado para os filtros actuais.</span>
              )}
            </div>
          </div>

          {/* PAGINAÇÃO (some se pageCount=1) */}
          <div className="d-flex justify-content-end mt-2">
            {renderPagination(pageCount, currentPage, setCurrentPage)}
          </div>
        </div>

        {/* MODAL CONFIRMAÇÃO */}
        <Modal show={showModal} onHide={() => setShowModal(false)} centered className="pretty-modal">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="bi bi-exclamation-triangle-fill me-2" style={{ color: "#ef4444" }} />
              Confirmar anulação
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            Tem certeza que deseja <strong>anular</strong> este pagamento de SMS?
            <div className="small-muted mt-2">
              Esta ação pode reverter os créditos atribuídos à instituição.
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" size="sm" onClick={() => setShowModal(false)}>
              Cancelar
            </Button>
            <Button variant="danger" size="sm" onClick={handleSmsCancel}>
              Confirmar anulação
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default SmsPaymentsTable;
